/* eslint-disable no-new */
import {
  listPerInvoice,
  totalTrxPerInvoice,
  listPerProduct,
  totalTrxPerProduct,
  listPerCashier,
  totalTrxPerCashier,
  listPerShift,
  totalTrxPerShift,
  listPerPembayaranPiutang,
  totalTrxPerPembayaranPiutang,
  listPerTipePembayaran,
  totalTrxPerTipePembayaran,
  listPerDokter,
  totalTrxPerDokter,
  listPerPelanggan,
  totalTrxPerPelanggan,
  listPerTipeProduk,
  totalTrxPerTipeProduk,
  listPerUmurPiutang,
  totalTrxPerUmurPiutang,
  listPerPiutang
} from '@/api/reportSale'

const actions = {
  listPerInvoice({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerInvoice(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerInvoice({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerInvoice(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerProduct({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerProduct(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerProduct({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerProduct(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerCashier({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerCashier(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerCashier({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerCashier(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerShift({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerShift(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerShift({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerShift(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerPembayaranPiutang({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerPembayaranPiutang(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerPembayaranPiutang({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerPembayaranPiutang(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerTipePembayaran({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerTipePembayaran(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerTipePembayaran({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerTipePembayaran(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerDokter({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerDokter(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerDokter({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerDokter(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerPelanggan({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerPelanggan(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerPelanggan({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerPelanggan(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerTipeProduk({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerTipeProduk(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerTipeProduk({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerTipeProduk(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerUmurPiutang({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerUmurPiutang(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerUmurPiutang({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      totalTrxPerUmurPiutang(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerPiutang({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      listPerPiutang(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reportSale.js